export default {
      id: "i-analytic-services-04-usage",
      viewBox: "0 0 134 112",
      url: __webpack_public_path__ + "img/sprite.svg#i-analytic-services-04",
      toString: function () {
        return this.url;
      }
    }